
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/first-time-hire",
      function () {
        return require("private-next-pages/first-time-hire.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/first-time-hire"])
      });
    }
  